import { render, staticRenderFns } from "./SubscriptionExpiryAlert.vue?vue&type=template&id=1ba8b9a8&scoped=true&"
import script from "./SubscriptionExpiryAlert.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionExpiryAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8b9a8",
  null
  
)

export default component.exports